import React from 'react';

import Button from '../../../components/ui/Button';

const MonthSelector = ({ selectedMonth, onMonthChange, availableMonths }) => {
  const currentIndex = availableMonths?.findIndex(m => m === selectedMonth);
  const canGoPrevious = currentIndex > 0;
  const canGoNext = currentIndex < availableMonths?.length - 1;

  const handlePrevious = () => {
    if (canGoPrevious) {
      onMonthChange(availableMonths?.[currentIndex - 1]);
    }
  };

  const handleNext = () => {
    if (canGoNext) {
      onMonthChange(availableMonths?.[currentIndex + 1]);
    }
  };

  const formatMonth = (monthStr) => {
    const [year, month] = monthStr?.split('-');
    const date = new Date(year, month - 1);
    return date?.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  };

  return (
    <div className="flex items-center justify-between bg-card rounded-lg p-16 md:p-20 lg:p-24 shadow-elevation-2">
      <Button
        variant="ghost"
        size="icon"
        onClick={handlePrevious}
        disabled={!canGoPrevious}
        iconName="ChevronLeft"
        iconSize={20}
        className="min-w-[44px] min-h-[44px]"
      />
      
      <div className="flex-1 text-center">
        <h2 className="text-lg md:text-xl lg:text-2xl font-heading font-semibold text-card-foreground">
          {formatMonth(selectedMonth)}
        </h2>
      </div>

      <Button
        variant="ghost"
        size="icon"
        onClick={handleNext}
        disabled={!canGoNext}
        iconName="ChevronRight"
        iconSize={20}
        className="min-w-[44px] min-h-[44px]"
      />
    </div>
  );
};

export default MonthSelector;